import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { StyledScoringBoard, StyledScoringPriorityColumn } from "./styles";

export const ScoringBoardLoader = () => (
    <Stack
        gap="24px"
        width="100%"
        data-automation="scoring-board-loader"
    >
        <StyledScoringBoard>
            {Array.from({ length: 3 }, (_, index) => (
                <StyledScoringPriorityColumn
                    key={index}
                    gap="12px"
                >
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <PixelPlaceholderLoader
                            width={72}
                            height={16}
                        />
                        <PixelPlaceholderLoader
                            width={88}
                            height={28}
                        />
                    </Flex>
                    <PixelPlaceholderLoader
                        width="100%"
                        height={120}
                    />
                </StyledScoringPriorityColumn>
            ))}
        </StyledScoringBoard>
    </Stack>
);
